import { apiRequest } from './apiClient';

const jsonOptions = (method, payload) => ({
  method,
  body: JSON.stringify(payload || {}),
});

export const fetchAdminUsers = () => apiRequest('/api/v1/admin/users');

export const updateAdminUser = (payload) => apiRequest(
  '/api/v1/admin/users',
  jsonOptions('PATCH', payload),
);

export const deleteAdminUser = (username) => apiRequest(
  '/api/v1/admin/users',
  jsonOptions('DELETE', { username }),
);

export const fetchGlobalMfaRequirement = () => apiRequest('/api/v1/admin/mfa-requirement');

export const setGlobalMfaRequirement = (required) => apiRequest(
  '/api/v1/admin/mfa-requirement',
  jsonOptions('POST', { required }),
);

export const fetchMfaStatus = () => apiRequest('/api/v1/account/mfa-status');

export const changeAccountPassword = (currentPassword, newPassword) => apiRequest(
  '/api/v1/account/password',
  jsonOptions('POST', { currentPassword, newPassword }),
);

export const beginMfaSetup = () => apiRequest(
  '/api/v1/account/mfa/setup',
  jsonOptions('POST'),
);

export const verifyMfaSetup = (code) => apiRequest(
  '/api/v1/account/mfa/verify',
  jsonOptions('POST', { code }),
);

export const disableMfa = (password, code) => apiRequest(
  '/api/v1/account/mfa/disable',
  jsonOptions('POST', { password, code }),
);

export const saveModel = (payload) => apiRequest(
  '/api/v1/admin/models',
  jsonOptions('POST', payload),
);

export const deleteModel = (payload) => apiRequest(
  '/api/v1/admin/models',
  jsonOptions('DELETE', payload),
);

export const savePluginFiles = (folderName, payload) => apiRequest(
  `/api/v1/settings/plugins/${encodeURIComponent(folderName)}/files`,
  jsonOptions('PUT', payload),
);

export const fetchPluginLogs = (folderName, limit = 100) => apiRequest(
  `/api/v1/settings/plugins/${encodeURIComponent(folderName)}/logs?limit=${encodeURIComponent(limit)}`,
);

export const fetchPluginVersions = (folderName, limit = 100) => apiRequest(
  `/api/v1/settings/plugins/${encodeURIComponent(folderName)}/versions?limit=${encodeURIComponent(limit)}`,
);

export const restorePluginVersion = (folderName, versionId) => apiRequest(
  `/api/v1/settings/plugins/${encodeURIComponent(folderName)}/versions/${encodeURIComponent(versionId)}/restore`,
  jsonOptions('POST'),
);

export const deletePlugin = (folderName) => apiRequest(
  `/api/v1/settings/plugins/${encodeURIComponent(folderName)}`,
  { method: 'DELETE' },
);

export const reloadPlugins = () => apiRequest(
  '/api/v1/settings/plugins/reload',
  jsonOptions('POST'),
);
